var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header',{attrs:{"username":_vm.user.name,"usermail":_vm.user.mail_alias || _vm.user.mail}}),_c('div',{attrs:{"id":"contentContainer"}},[_c('div',{attrs:{"id":"contentWrapper"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }